import component from './index.vue'

const Plugin = {
  install (Vue, options = {}) {
    if (this.installed) {
      return
    }
    this.installed = true
    this.event = new Vue()

    Vue.component('searchPlaceInput', component)
    // Vue.mixin({
    // })

    Vue.prototype.$searchPlaceInput = {
      // doValidate () {
      //   Plugin.event.$emit('doValidate')
      // },
      // focus () {
      //   Plugin.event.$emit('focus')
      // }
    }
  }
}

// This exports the plugin object.
export default Plugin
